<div class="landing-wrapper">
  <app-landing-banner></app-landing-banner>
  <app-landing-services></app-landing-services>
  <app-landing-categories></app-landing-categories>
  <app-landing-special-taager></app-landing-special-taager>
  <app-landing-testimonials></app-landing-testimonials>
  <app-faq [questions]="faqQuestions"></app-faq>
  <app-download-and-join-taager></app-download-and-join-taager>
</div>
